import { render, staticRenderFns } from "./approvalCommon.pug?vue&type=template&id=dc9991be&lang=pug&"
import script from "./approvalCommon.ts?vue&type=script&lang=ts&"
export * from "./approvalCommon.ts?vue&type=script&lang=ts&"
import style0 from "./approvalCommon.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports